export default "__VITE_ASSET__CCbSLPj6__"